<template>
  <div v-zpm="{ sectionid: 161 }" class="wear-wrapper">
    <div class="wear-content" :class="{ other_env: !env }" @click="refPopupWearClick()">
      <div v-zpm="{ sortname: '佩戴效果', sortid: 2 }" class="content-top">
        <div class="wear-title">佩戴示意</div>
        <img class="img-wear" :src="$setPicSize(wearingInfo.pic || '')" alt="" />
      </div>

      <div class="content-title">
        <div class="title-desc">
          * 佩戴效果非本商品，示例图表壳直径<span v-if="wearingInfo">{{
            wearingInfo.showText || ''
          }}</span>
        </div>
        <div class="title-check">
          来试试你的佩戴效果
          <img
            :src="
              $setPicSize(
                'https://pic3.zhuanstatic.com/zhuanzh/ee0cbe6f-61af-446b-bf27-644d4e45c07e.png'
              )
            "
            class="arrow"
          />
        </div>
      </div>

      <popupWear ref="refPopupWear" :dataInfo="dataInfo" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from '@vue/composition-api'
import { state } from '@/store'
import { isPlatform } from '@utils/native'

import popupWear from './popup-wear.vue'

export default defineComponent({
  components: {
    popupWear
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const env = isPlatform('zz')

    const refPopupWear = ref(null)

    /**
     * $ 佩戴效果数据
     */
    // TODO: 二奢融合 佩戴效果数据
    const wearingInfo = computed(() => {
      return props?.dataInfo?.wearingInfo
    })

    /**
     * $ 查看佩戴效果
     */
    // TODO: 二奢融合 佩戴效果
    const refPopupWearClick = () => {
      refPopupWear?.value.openWearPopup()
    }

    return {
      state,
      isPlatform,
      env,
      refPopupWearClick,
      refPopupWear,
      wearingInfo
    }
  }
})
</script>

<style lang="scss" scoped>
.wear-wrapper {
  position: relative;
  width: 100%;
  height: 100vw;
  background: #f8f8f8f8;

  .wear-content {
    position: absolute;
    bottom: 80px;
    left: 0;
    box-sizing: border-box;
    width: calc(100% - 64px);
    height: 480px;
    margin: 0 32px;
    padding: 32px 0 0;
    background: #fff;
    border-radius: 16px;

    .content-top {
      .wear-title {
        margin-left: 32px;
        color: #000;
        font-weight: 400;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        line-height: 28px;
      }
      .img-wear {
        width: 100%;
        height: 310px;
      }
    }
    .content-title {
      margin-top: -8px;
      text-align: center;
      .title-desc {
        margin-bottom: 18px;
        color: #999;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        line-height: 30px;
        span {
          color: #000;
        }
      }
      .title-check {
        color: #000;
        font-weight: 300;
        font-size: 22px;
        font-family: PingFangSC, PingFang SC;
        line-height: 24px;
        img {
          position: relative;
          top: 4px;
          width: 24px;
          height: 24px;
          object-fit: cover;
        }
      }
    }
    // &.other_env {
    //    margin-bottom: 165px;
    // }
  }
}
</style>
